import React from "react";
import { Link } from "react-router-dom";

type BreadcrumbItem = {
  label: string;
  to?: string;
};

/**
 * Tailwind-styled Breadcrumbs component
 * Uses semantic nav > ol markup and supports links for all but the last item.
 */
export default function Breadcrumbs({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav className="my-6" aria-label="Breadcrumb">
      <div className="bg-white rounded-md px-3 py-2 inline-block shadow-sm">
        <ol className="list-none p-0 m-0 flex items-center text-sm">
          {items.map((it, idx) => {
            const isLast = idx === items.length - 1;
            return (
              <li key={it.label} className="flex items-center">
                {!isLast && it.to ? (
                  <Link
                    to={it.to}
                    className="text-primary-default hover:text-primary-surface transition-colors duration-300"
                  >
                    {it.label}
                  </Link>
                ) : isLast ? (
                  <span className="tfext-black font-medium">{it.label}</span>
                ) : (
                  <span className="text-gray-700">{it.label}</span>
                )}

                {!isLast && (
                  <span className="mx-2 text-gray-300" aria-hidden>
                    /
                  </span>
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
  );
}
